import { ArrowUpRight } from "lucide-react";
import Reveal from "@/components/Reveal";
import { LINKS } from "@/lib/site";

const STATS = [
  { v: "2×", l: "PHD — DOCTORATES" },
  { v: "52", l: "PATENTS — 33 GRANTED" },
  { v: "23", l: "PEER-REVIEWED PUBLICATIONS" },
  { v: "5", l: "INVITED TALKS" },
  { v: "6", l: "UNIVERSITY COURSES" },
];

const LINKS_UI = [
  ["GOOGLE SCHOLAR", LINKS.scholar, "credibility-scholar-link"],
  ["LINKEDIN", LINKS.linkedin, "credibility-linkedin-link"],
];

export default function CredibilityStrip() {
  return (
    <section data-testid="credibility-strip" className="border-t border-white/10 bg-ink-900">
      <div className="mx-auto flex max-w-7xl flex-col justify-between gap-12 px-6 py-20 lg:flex-row lg:items-center lg:px-10">
        <Reveal className="flex flex-wrap gap-x-16 gap-y-10">
          {STATS.map(({ v, l }) => (
            <div key={l}>
              <p className="font-display text-3xl font-black tracking-tight text-white sm:text-4xl">{v}</p>
              <p className="mt-2 font-mono text-[10px] tracking-[0.25em] text-fog">{l}</p>
            </div>
          ))}
        </Reveal>

        <Reveal delay={0.1} className="flex flex-wrap gap-3">
          {LINKS_UI.map(([label, href, tid]) => (
            <a
              key={label}
              data-testid={tid}
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              className="group flex items-center gap-2 border border-white/20 px-5 py-3 font-mono text-[11px] tracking-[0.2em] text-white transition-colors hover:border-accent hover:text-accent"
            >
              {label}
              <ArrowUpRight className="h-3.5 w-3.5 transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
            </a>
          ))}
        </Reveal>
      </div>
    </section>
  );
}
